<template>
    <el-main class="site-content main-page">
        <div @mousemove="mousemoveHandler" class="main-page__grid">
            <h1 class="visually-hidden">Национальное агенство развития квалификаций. Главная страница.</h1>
            <section class="main-page__section main-page__section--light">
                <h2 class="main-page__title">Отраслевые рамки квалификаций</h2>
                <template v-if="!accessToken">
                    <p class="main-page__text">Войдите, используя аккаунт на Едином портале <br>Национальной системы квалификаций.</p>
                    <button class="btn btn_primary main-page__link" @click="elDialogs.login = true">Войти в&nbsp;портал</button>
                </template>

                <template v-else>
                    <p class="main-page__text">Начните работать с отраслевыми рамками квалификаций.</p>
                    <button class="btn btn_primary main-page__link" @click="goTo('Profile')">Перейти к редактированию ОРК</button>
                </template>

                <div class="triangles">
                    <div class="main-page__triangle-wrap position-1" :style="rotate">
                        <div class="main-page__triangle size-s color-red delta-4 time-1"></div>
                    </div>
                    <div class="main-page__triangle-wrap position-2" :style="raiseRotate">
                        <div class="main-page__triangle reversed delta-4"></div>
                    </div>
                    <div class="main-page__triangle-wrap position-3" :style="rotate">
                        <div class="main-page__triangle reversed size-l color-lightblue3 delta-2"></div>
                    </div>
                    <div class="main-page__triangle-wrap position-4" :style="rotate">
                        <div class="main-page__triangle reversed size-xl color-lightblue3 delta-1 time-3"></div>
                    </div>
                    <div class="main-page__triangle-wrap position-5" :style="raiseRotate">
                        <div class="main-page__triangle reversed size-m color-darkblue delta-3 time-3"></div>
                    </div>
                    <div class="main-page__triangle-wrap position-6" :style="rotate">
                        <div class="main-page__triangle color-darkblue delta-3 time-1"></div>
                    </div>
                    <div class="main-page__triangle-wrap position-7" :style="rotate">
                        <div class="main-page__triangle reversed color-red delta-2 time-2"></div>
                    </div>
                </div>
            </section>
            <section class="main-page__section main-page__section--dark">
                <h2 class="main-page__title">Постройте свою <br>карьерную траекторию</h2>
                <p class="main-page__text">Ответьте на&nbsp;вопросы и&nbsp;узнайте <br>свою карьерную траекторию</p>
                <button class="btn main-page__link" @click="goTo('CareerTrajectory')">Построить траекторию</button>

                <div class="triangles">
                    <div class="main-page__triangle-wrap position-8" :style="rotate">
                        <div class="main-page__triangle reversed size-xl color-darkblue delta-2 time-3"></div>
                    </div>
                    <div class="main-page__triangle-wrap position-9" :style="raiseRotate">
                        <div class="main-page__triangle reversed color-lightblue1 size-m delta-2 time-3"></div>
                    </div>
                    <div class="main-page__triangle-wrap position-10" :style="rotate">
                        <div class="main-page__triangle color-red delta-2 time-1"></div>
                    </div>
                    <div class="main-page__triangle-wrap position-11" :style="rotate">
                        <div class="main-page__triangle reversed size-l color-red delta-4 time-4"></div>
                    </div>
                    <div class="main-page__triangle-wrap position-12" :style="rotate">
                        <div class="main-page__triangle size-xl color-lightblue1 delta-2 time-2"></div>
                    </div>
                    <div class="main-page__triangle-wrap position-13" :style="raiseRotate">
                        <div class="main-page__triangle color-lightblue2 size-m delta-4 time-2"></div>
                    </div>
                </div>
            </section>
        </div>
    </el-main>
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import { throttle } from '../helpers.js';

import dialog from '@/mixins/dialog';

export default {
    mixins: [ dialog ],
    data() {
        return {
            rotateX: 30,
            rotateY: 30,
        }
    },
    computed: {
        ...mapState('tokens', ['accessToken', 'accessTokenInitTime']),

        rotate: function () {
            return `transform: rotateX(${this.rotateX}deg) rotateY(${this.rotateY}deg)`;
        },
        raiseRotate: function () {
            return `transform: translateZ(150px) rotateX(${this.rotateX}deg) rotateY(${this.rotateY}deg)`;
        }
    },
    methods: {
        mousemoveHandler(evt) {
            this.rotateX = Math.round((window.innerHeight / 2 - evt.y) / -10);
            this.rotateY = Math.round((window.innerWidth / 2 - evt.x) / -25);
        },
        goTo(name) {
            this.$router.push({ name: name })
        }
    }
};
</script>
